export const getStaffingColor = (percent) => {
  if (percent >= 93) return "green";
  if (percent >= 80) return "orange";
  return "red";
};

export const getTurnoverBarColor = (status) =>
  status === "risk" ? "#e57373" : "#81c784";

export const formatPercent = (value) => {
  if (value == null || Number.isNaN(value)) return "—";
  const normalized = Number(value);
  const text = Number.isInteger(normalized)
    ? String(normalized)
    : normalized.toFixed(1).replace(".", ",");
  return `${text}%`;
};

export const formatDeficit = (value) => (value > 0 ? `+${value}` : `${value}`);

export const formatNumber = (value) => {
  if (value == null || Number.isNaN(value)) return "—";
  return value;
};
